import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const token = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("token");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/portal/login"), 2500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-screen bg-[#191713] flex items-center justify-center px-6" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-[#23201A] gold-keyline p-8 sm:p-10">
        <h1 className="font-serif text-2xl text-[#F7F3EC]">{t.login2.resetTitle}</h1>
        {done ? (
          <p className="mt-6 text-sm text-emerald-400" data-testid="reset-success">{t.login2.resetDone}</p>
        ) : (
          <form onSubmit={submit} className="mt-7 space-y-5">
            <div>
              <label className="field-label" htmlFor="new-password">{t.login2.newPassword}</label>
              <input id="new-password" type="password" minLength={8} data-testid="reset-password-input"
                className="field-input-dark" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && <p className="text-sm text-red-400" role="alert" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={busy || !token} data-testid="reset-submit-button" className="btn-gold w-full disabled:opacity-60">
              {t.login2.resetSubmit}
            </button>
          </form>
        )}
        <Link to="/portal/login" className="mt-6 block text-center text-sm text-[#9A9184] hover:text-[#B8933F] transition-colors">
          {t.login.back}
        </Link>
      </div>
    </main>
  );
}
